const { env, domainsMap } = require("../config");

const getDomain = (url = null) => {
	let _hostname = null;

	if (url) {
		_hostname = new URL(url).hostname;
	} else {
		if (window.location != window.parent.location) {
			let _domainReferrer = document.referrer;

			if (!_domainReferrer) {
				_domainReferrer = "https://sinao.test";
			}

			_hostname = new URL(_domainReferrer).hostname;
		} else {
			_hostname = document.location.hostname;
		}
	}

	// const _hostname = url ? new URL(url).hostname : window.location.hostname;

	return _hostname.split(".").slice(-2).join(".");
};

const isSinaoDomain = domain => {
	return domainsMap.has(domain);
};

const getEnvironment = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const envString = urlParams.get("env");

	if (envString) {
		switch (envString) {
			case "local":
				return env.local;

			case "staging":
				return env.staging;

			case "production":
				return env.production;
		}
	} else {
		const domain = module.exports.getDomain();

		if (module.exports.isSinaoDomain(domain)) {
			return env[domainsMap.get(domain).env];
		}
	}

	return env.production;
};

const getDebugMode = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const debugString = urlParams.get("debug");

	return debugString !== null;
};

const compareKeys = (requiredKeys, providedKeys) => {
	try {
		const _providedKeys = Array.isArray(providedKeys) ? providedKeys : Object.keys(providedKeys);

		let requiredKeysExist;

		for (const requiredKey of requiredKeys) {
			requiredKeysExist = null;

			for (const providedKey of _providedKeys) {
				if (requiredKey === providedKey) {
					requiredKeysExist = true;
					break;
				} else {
					requiredKeysExist = false;
				}
			}

			if (!requiredKeysExist) {
				break;
			}
		}

		return requiredKeysExist;
	} catch (error) {
		console.log("[methods.js][compareKeys]", error);

		throw new Error(error);
	}
};

const getValueByKeyNames = (obj, keys) => {
	let target = obj;

	for (let i = 0; i < keys.length; i++) {
		if (target[keys[i]]) {
			target = target[keys[i]];
		} else {
			target = null;
			break;
		}
	}

	return target;
};

const formatDate = (dateString, US = false) => {
	if (!dateString) {
		return;
	}

	const date = new Date(dateString);

	const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;

	const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;

	const year = date.getFullYear();

	if (US) {
		return `${year}-${month}-${day}`;
	}

	return `${day}/${month}/${year}`;
};

const convertNumberToString = (value, maximumFractionDigits = 2) => {
	maximumFractionDigits = typeof maximumFractionDigits === "number" ? maximumFractionDigits : 5;

	// .format require a number so we convert the string to number first
	const number = convertStringToNumber(value);

	const amount = new Intl.NumberFormat("fr-FR", {
		minimumFractionDigits: maximumFractionDigits < 2 ? 0 : 2,
		maximumFractionDigits
	}).format(number);

	return amount;
};

const convertStringToNumber = value => {
	let _value = String(value).replace(/\s/g, "").replace(",", ".");

	const float = parseFloat(_value);

	if (isNaN(float)) {
		return 0.0;
	}

	return float;
};

module.exports = {
	getDomain,
	isSinaoDomain,
	getEnvironment,
	getDebugMode,
	compareKeys,
	getValueByKeyNames,
	formatDate,
	convertNumberToString,
	convertStringToNumber
};
